/* global localData */
if (document.querySelector('.sc-contact-form')) {
  const contactForm = (() => {
    const r = {
      inputs: document.querySelectorAll('.sc-contact-form input, textarea'),
      button: document.querySelector('.sc-contact-form .btn'),
      sendForm: (formData) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', localData.siteURL);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function () {
          if (xhr.status === 200) {
            const response = JSON.parse(this.responseText);
            if (response.data.status === 200) {
              document.querySelector('.sc-contact-form .contact-form').innerHTML = `<h2>${response.data.msg}</h2>`;
            } else {
              document.querySelector('.sc-contact-form .contact-form').innerHTML = '<h2>Something went wrong.</h2>';
            }
          }
        };
        xhr.send(`action=contactForm&inputs=${encodeURI(JSON.stringify(formData))}&lang=${localData.lang}&nonce=${localData.nonce}&id=${localData.id}&url=${localData.currentUrl}`);
      },
      validateEmail: (mail) => mail.search(/^[\w\d._-]+@[\w\d\-_.]+\.[\d\w][\d\w]+$/) > -1,
      checkInputs: () => {
        let isValid = true;
        const formData = {};
        r.inputs.forEach((input) => {
          const type = input.tagName === 'TEXTAREA' ? input.tagName : input.getAttribute('type');
          switch (type) {
            case 'TEXTAREA':
            case 'text':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.parentNode.classList.add('is-failed');
                isValid = false;
              } else {
                input.parentNode.classList.remove('is-failed');
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string' && !r.validateEmail(formData[input.name])) {
                input.parentNode.classList.add('is-failed');
                isValid = false;
              } else {
                input.parentNode.classList.remove('is-failed');
              }
              break;
            case 'checkbox':
              if (!input.checked) {
                isValid = false;
                input.parentNode.classList.add('is-failed');
              } else {
                input.parentNode.classList.remove('is-failed');
              }
              break;
            default:
          }
        });
        if (isValid) {
          r.sendForm(formData);
        }
      },
      initButtons: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.checkInputs();
        });
      },
    };
    return {
      initialize: () => {
        r.initButtons();
      },
    };
  })();
  contactForm.initialize();
}
